
/**
 * 보안 검증 상태 (진행 중, 통과, 실패)
 */
export type SaveProject201SecurityCheckStatus = typeof SaveProject201SecurityCheckStatus[keyof typeof SaveProject201SecurityCheckStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SaveProject201SecurityCheckStatus = {
  pending: 'pending',
  passed: 'passed',
  failed: 'failed',
} as const;
